export default {
  couponCodeList(state) {
    return state.couponCodeList;
  },
  getCouponEdit(state) {
    return state.currentCouponObject;
  }
};
